import React, { useEffect } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { Link } from 'react-router-dom';
function PledgeAnthem() {
    useEffect(() => {
        document.title = ' School Pledge & Anthem -  CARMEL CONVENT SCHOOL, DHARUHERA';
    }, []);
    return (
        <>
            <Header />
            <div className="sliderbg"></div>
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <ul className="breadcrumbli">
                                <li><Link to="/"> Home </Link></li>
                                <li>About Us</li>
                                <li> School Pledge & Anthem</li>
                            </ul>
                        </div>
                        <div className="col-lg-12">
                            <h2 className="innerheading"> School Pledge & Anthem</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <h5 className="mb-4">School Pledge</h5>
                            <p>
                                India is my country, all Indians are my brothers and sisters.<br />
                                I love my country, and I am proud of its rich and varied heritage. I shall always strive to be worthy of it.<br />
                                I shall give respect to my parents, teachers and elders and treat everyone with courtesy.<br />
                                To my country and my people, I pledge my devotion. In their well-being and prosperity alone, lies my happiness.
                            </p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="anthem-section">

                                <h5 className="mb-4 anthem-heading">School Anthem</h5>

                                <div className="anthem-wrapper">

                                    <div className="anthem-side anthem-side-left">
                                        <div className="anthem-pattern"></div>
                                    </div>

                                    <p className="anthem-text">
                                        A Happy band from far and near<br />
                                        Dear Carmel children, we gather here<br />
                                        Beloved School, Dear Carmel hail<br />
                                        Our love for thee shall never fail.<br />
                                        Ch : For God is all our strength<br />
                                        In Him we do and dare<br />
                                        The right against the wrong<br />
                                        We cherish and revere.<br />
                                        Then proudly let us stand<br />
                                        United heart and hand<br />
                                        And Pray that God may bless<br />
                                        And keep our Carmel School<br />
                                        Dear Carmel School we’ll ever be<br />
                                        In faith and love and true to thee,<br />
                                        And all our days, a song of praise<br />
                                        Shall echo in our hearts always.<br />
                                        Ch : For God is all our strength<br />
                                        In Him we do and dare<br />
                                        The right against the wrong<br />
                                        We cherish and revere.<br />
                                        Then proudly let us stand<br />
                                        United heart and hand<br />
                                        And Pray that God may bless<br />
                                        And keep our Carmel School
                                    </p>

                                    <div className="anthem-side anthem-side-right">
                                        <div className="anthem-pattern"></div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default PledgeAnthem